import type { TFunction } from 'i18next';
import { displayNameOf, type InvitationBody, type Member } from './team.ts';

export type InvitationOutcome = { readonly invitationSent: boolean; readonly member: Member | null };

export const invitationMessage = (t: TFunction, body: InvitationBody, outcome: InvitationOutcome): string => {
  if (outcome.invitationSent) return t('team.invited', { email: body.email });
  const name = outcome.member === null ? body.firstName : displayNameOf(outcome.member);
  return outcome.member?.invitationPending === true
    ? t('team.invitedNoEmail', { name })
    : t('team.added', { name });
};
